__webpack_require__.p = "https://beta.eu.safer.whs.amazon.dev/";